import { useIntl } from 'react-intl';
import { EmptyState } from '@rossum/components/empty-state/EmptyState';

export const MissingInfoEmptyState = ({
  lookupLabel,
  lookupSchemaId,
}: {
  lookupLabel: string;
  lookupSchemaId: string;
}) => {
  const intl = useIntl();

  return (
    <EmptyState
      title={intl.formatMessage({
        id: 'features.queueSettings.fields.lookup.emptyState.missingInfo.title',
      })}
      description={intl.formatMessage(
        {
          id: 'features.queueSettings.fields.lookup.emptyState.missingInfo.description',
        },
        {
          missingInfo: [
            lookupLabel === '' &&
              intl.formatMessage({
                id: 'features.queueSettings.fields.lookup.emptyState.missingInfo.label',
              }),
            lookupSchemaId === '' &&
              intl.formatMessage({
                id: 'features.queueSettings.fields.lookup.emptyState.missingInfo.fieldId',
              }),
          ]
            .filter(Boolean)
            .join(', '),
        }
      )}
    />
  );
};
